import React, { useEffect, useState } from 'react';
import { Popover } from '@nackle/origami';
import ReactTimeAgo from 'react-time-ago';
import { tabbable } from 'tabbable';
import classNames from 'classnames';
import { LocaleString, getString } from '@nackle/intl-tools';
import { UpdateStatus, DeleteNotification } from '../fetch-notifications.js';
import { Bell, MoreDotsVert, Check, Close } from '@nackle/origami-icons';

import './notifications-popover.less';

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import fr from 'javascript-time-ago/locale/fr';
import frCA from 'javascript-time-ago/locale/fr-CA';
import de from 'javascript-time-ago/locale/de';
import enGB from 'javascript-time-ago/locale/en-GB';
import it from 'javascript-time-ago/locale/it';
import ja from 'javascript-time-ago/locale/ja';
import ko from 'javascript-time-ago/locale/ko';
import nl from 'javascript-time-ago/locale/nl';
import pl from 'javascript-time-ago/locale/pl';
import pt from 'javascript-time-ago/locale/pt';
import ru from 'javascript-time-ago/locale/ru';
import tk from 'javascript-time-ago/locale/tk';
import zh from 'javascript-time-ago/locale/zh';
import zhHant from 'javascript-time-ago/locale/zh-Hant';
import es from 'javascript-time-ago/locale/es';
import esMX from 'javascript-time-ago/locale/es-MX';
import th from 'javascript-time-ago/locale/th';
import vi from 'javascript-time-ago/locale/vi';

const locales = [ fr, frCA, de, enGB, it, ja, ko, nl, pl, pt, ru, tk, zh, zhHant, es, esMX, th, vi ];
locales.forEach( locale => TimeAgo.addLocale( locale ) );

if ( TimeAgo.getDefaultLocale() !== 'en' ) {
    TimeAgo.addDefaultLocale( en );
} else {
    TimeAgo.addLocale( en );
}

export const NotificationsPopover = ( { dataSource, locale, closePopovers, token, onChange } ) => {
    const [ notifications, setNotifications ] = useState( dataSource );
    //for some reason dataSource isn't getting applied with useState on mobile.
    if ( dataSource && dataSource.length > 0 && notifications && notifications.length === 0 ) {
        setNotifications( dataSource );
    }
    const [ focusable, setFocusable ] = useState();
    const handleBlur = e => e.target === focusable[ focusable.length - 1 ] ? closePopovers() : false;

    useEffect( () => {
        setFocusable( tabbable( document.querySelector( '.notifications-popover-container' ) ) );
    }, [] );

    const removeNotification = ( id ) => {
        const newNotifications = notifications.filter( notification => notification.id !== id );
        if ( typeof onChange === 'function' ) {
            const unreadNotificationCount = newNotifications.reduce( ( accumulator, item ) => {
                return item.status === 'UNREAD'
                    ? accumulator + 1
                    : accumulator;
            }, 0 );
            onChange( unreadNotificationCount );
        }
        setNotifications( newNotifications );
    };

    const updateStatus = ( id, status ) => {
        const newNotifications = notifications.map( notification => {
            if ( notification.id === id ) {
                notification.status = status;
            }
            return notification;
        } );
        if ( typeof onChange === 'function' ) {
            const unreadNotificationCount = newNotifications.reduce( ( accumulator, item ) => {
                return item.status === 'UNREAD'
                    ? accumulator + 1
                    : accumulator;
            }, 0 );
            onChange( unreadNotificationCount );
        }
        setNotifications( newNotifications );
    };

    return (
        <div className="notifications-popover-container" onBlur={ handleBlur }>
            <div className="rewards-popover-section rewards-section">
                <div className="rewards-header deck-notifications-header">
                    <span className="anticon nkl-deck-icon"><Bell className="reward-gift-icon deck-primary-color" /></span>
                    <span className="gift-code-callout-header"><LocaleString code="deck.notifications.header" /></span>
                </div>
                { notifications && notifications.length > 1
                    // if notifications exist
                    ? <ul className="deck-notifications-list">
                        {
                            notifications.map( ( item, index ) => {
                                const itemClasses = classNames( {
                                    inactive: item.status === 'READ',
                                    'last-item': index === notifications.length - 1
                                } );

                                return <li key={ item.id } className={ itemClasses }>
                                    <Popover
                                        getPopupContainer={ triggerNode => triggerNode.parentNode }
                                        overlayClassName="nkl-deck-popover nkl-deck-popover-menu-container deck-notifications-options-menu-outer"
                                        placement="bottomRight"
                                        trigger="click"
                                        arrow={ false }
                                        autoAdjustOverflow={ false }
                                        content={ <NotificationOptionsMenu id={ item.id } status={ item.status } token={ token } removeNotification={ removeNotification } updateStatus={ updateStatus } /> }
                                    >
                                        <button onClick={ ( e ) => e.preventDefault() } className="deck-single-notification-more" aria-label={ getString( 'deck.label.notificationsMenu' ) }>
                                            <span className="anticon nkl-deck-icon"><MoreDotsVert /></span>
                                        </button>
                                    </Popover>
                                    <div className="deck-notifications-content-outer">
                                        <div className="deck-notifications-content" dangerouslySetInnerHTML={ { __html: item.content } } />
                                        <p className={ `deck-notifications-item-meta ${ item.status === 'UNREAD' ? 'deck-primary-color' : '' }` }>
                                            <ReactTimeAgo
                                                className={ `${ item.status === 'UNREAD' ? 'primary-color' : '' }` }
                                                date={ new Date( item.timestamp ) }
                                                locale={ locale === 'zh-TW' ? 'zh-Hant' : locale }
                                            />
                                        </p>
                                    </div>
                                </li>;
                            } )
                        }
                    </ul>

                    // Empty state for no notifications
                    : <div className="deck-notifications-empty">
                        <img src={ 'https://api.biw.cloud/v1/images/notifications-empty.png' } alt={ getString( 'deck.notificationsPopover.headerTitle' ) } />
                        <h4><LocaleString code="deck.notificationsPopover.headerTitle" /></h4>
                        <p><LocaleString code="deck.notificationsPopover.bodyText" /></p>
                    </div>
                }</div>
        </div>
    );
};

export default NotificationsPopover;

const NotificationOptionsMenu = ( { token, id, status, removeNotification, updateStatus } ) => {
    const changeStatus = async () => {
        const newStatus = status === 'READ' ? 'UNREAD' : 'READ';
        const result = await UpdateStatus( token, id, newStatus );

        if ( result.success ) {
            updateStatus( id, newStatus );
        }
    };

    const deleteNotification = async () => {
        const result = await DeleteNotification( token, id );

        if ( result.success ) {
            removeNotification( id );
        }
    };

    return <ul className="deck-notifications-options-menu">
        <li>
            <button onClick={ changeStatus }>
                <span className="anticon nkl-deck-icon primary-color"><Check /></span>
                { status === 'READ'
                    ? <LocaleString code="deck.notifications.markAsUnread" />
                    : <LocaleString code="deck.notifications.markAsRead" /> }
            </button>
        </li>
        <li>
            <button onClick={ deleteNotification }>
                <span className="anticon nkl-deck-icon primary-color"><Close /></span>
                <LocaleString code="deck.notifications.deleteNotification" />
            </button>
        </li>
    </ul>;
};
